import { render, staticRenderFns } from "./ChartFeaturesGroup.vue?vue&type=template&id=c8891704"
import script from "./ChartFeaturesGroup.vue?vue&type=script&lang=js"
export * from "./ChartFeaturesGroup.vue?vue&type=script&lang=js"
import style0 from "./ChartFeaturesGroup.vue?vue&type=style&index=0&id=c8891704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports